import { render } from "./chart.mobile.vue?vue&type=template&id=4b52b502&scoped=true&ts=true"
import script from "./chart.mobile.vue?vue&type=script&scoped=true&lang=ts"
export * from "./chart.mobile.vue?vue&type=script&scoped=true&lang=ts"

import "./chart.mobile.vue?vue&type=style&index=0&id=4b52b502&scoped=true&lang=css"

import exportComponent from "/usr/src/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b52b502"]])

export default __exports__